import { render, staticRenderFns } from "./GiftPdf.vue?vue&type=template&id=376a8246&"
import script from "./GiftPdf.vue?vue&type=script&lang=js&"
export * from "./GiftPdf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports